export const BRAND_META = {
    // ── Cars ──────────────────────────────────────────────────────────────────
    toyota:           { display: 'Toyota',          dbName: 'Toyota' },
    hyundai:          { display: 'Hyundai',          dbName: 'Hyundai' },
    bmw:              { display: 'BMW',              dbName: 'BMW' },
    'mercedes-benz':  { display: 'Mercedes-Benz',   dbName: 'Mercedes-Benz' },
    kia:              { display: 'Kia',              dbName: 'Kia' },
    lexus:            { display: 'Lexus',            dbName: 'Lexus' },
    honda:            { display: 'Honda',            dbName: 'Honda' },
    nissan:           { display: 'Nissan',           dbName: 'Nissan' },
    mazda:            { display: 'Mazda',            dbName: 'Mazda' },
    volkswagen:       { display: 'Volkswagen',       dbName: 'Volkswagen' },
    audi:             { display: 'Audi',             dbName: 'Audi' },
    ford:             { display: 'Ford',             dbName: 'Ford' },
    chevrolet:        { display: 'Chevrolet',        dbName: 'Chevrolet' },
    mitsubishi:       { display: 'Mitsubishi',       dbName: 'Mitsubishi' },
    subaru:           { display: 'Subaru',           dbName: 'Subaru' },
    suzuki:           { display: 'Suzuki',           dbName: 'Suzuki' },
    renault:          { display: 'Renault',          dbName: 'Renault' },
    'land-rover':     { display: 'Land Rover',       dbName: 'Land Rover' },
    porsche:          { display: 'Porsche',          dbName: 'Porsche' },
    jeep:             { display: 'Jeep',             dbName: 'Jeep' },
    smart:            { display: 'Smart',            dbName: 'Smart' },
    mini:             { display: 'Mini',             dbName: 'Mini' },
    skoda:            { display: 'Škoda',            dbName: 'Skoda' },
    seat:             { display: 'SEAT',             dbName: 'Seat' },
    volvo:            { display: 'Volvo',            dbName: 'Volvo' },
    opel:             { display: 'Opel',             dbName: 'Opel' },
    fiat:             { display: 'Fiat',             dbName: 'Fiat' },
    citroen:          { display: 'Citroen',          dbName: 'Citroen' },
    tesla:            { display: 'Tesla',            dbName: 'Tesla' },
    infiniti:         { display: 'Infiniti',         dbName: 'Infiniti' },
    acura:            { display: 'Acura',            dbName: 'Acura' },
    cadillac:         { display: 'Cadillac',         dbName: 'Cadillac' },
    dodge:            { display: 'Dodge',            dbName: 'Dodge' },
    chrysler:         { display: 'Chrysler',         dbName: 'Chrysler' },
    ram:              { display: 'RAM',              dbName: 'RAM' },
    lincoln:          { display: 'Lincoln',          dbName: 'Lincoln' },
    buick:            { display: 'Buick',            dbName: 'Buick' },
    gmc:              { display: 'GMC',              dbName: 'GMC' },
    jaguar:           { display: 'Jaguar',           dbName: 'Jaguar' },
    bentley:          { display: 'Bentley',          dbName: 'Bentley' },
    'aston-martin':   { display: 'Aston Martin',     dbName: 'Aston Martin' },
    ferrari:          { display: 'Ferrari',          dbName: 'Ferrari' },
    lamborghini:      { display: 'Lamborghini',      dbName: 'Lamborghini' },
    maserati:         { display: 'Maserati',         dbName: 'Maserati' },
    'alfa-romeo':     { display: 'Alfa Romeo',       dbName: 'Alfa Romeo' },
    saab:             { display: 'Saab',             dbName: 'Saab' },
    genesis:          { display: 'Genesis',          dbName: 'Genesis' },
    // ── Bikes ─────────────────────────────────────────────────────────────────
    aprilia:          { display: 'Aprilia',          dbName: 'APRILIA' },
    ducati:           { display: 'Ducati',           dbName: 'DUCATI' },
    'harley-davidson':{ display: 'Harley-Davidson',  dbName: 'HARLEY DAVIDSON' },
    indian:           { display: 'Indian',           dbName: 'INDIAN' },
    kawasaki:         { display: 'Kawasaki',         dbName: 'KAWASAKI' },
    ktm:              { display: 'KTM',              dbName: 'KTM' },
    'royal-enfield':  { display: 'Royal Enfield',    dbName: 'ROYAL ENFIELD' },
    triumph:          { display: 'Triumph',          dbName: 'TRIUMPH' },
    yamaha:           { display: 'Yamaha',           dbName: 'YAMAHA' },
    // ── Commercial ────────────────────────────────────────────────────────────
    daf:              { display: 'DAF',              dbName: 'DAF' },
    isuzu:            { display: 'Isuzu',            dbName: 'Isuzu' },
    iveco:            { display: 'IVECO',            dbName: 'IVECO' },
    man:              { display: 'MAN',              dbName: 'MAN' },
    peugeot:          { display: 'Peugeot',          dbName: 'Peugeot' },
    scania:           { display: 'Scania',           dbName: 'Scania' },
    gaz:              { display: 'GAZ',              dbName: 'GAZ' },
};

export const BRAND_SLUGS = Object.keys(BRAND_META);

/** Returns brand metadata for a given slug, or null if not found. */
export function getBrandMeta(slug) {
    return BRAND_META[slug] ?? null;
}
